// extracted by mini-css-extract-plugin
module.exports = {"otp-input":"otp-input-overrides_otp-input__24Cnm"};